
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/flamingo",
      function () {
        return require("private-next-pages/download/flamingo/index.tsx");
      }
    ]);
  